import React from "react";
import { GlassCard } from "../components/ui";
import { btn3d } from "../styles/buttonStyles";
import CommunityView from "../components/CommunityView";
import ItineraryDisplay from "../components/ItineraryDisplay";

export default function CommunityPage({ viewingCommunityTrip, setViewingCommunityTrip, dm, darkMode, communityTrips, reviews, personal, savedTrips, loggedInUser, shareSavedTripToCommunity, sharedTripIds, t, setCommunityTrips, deleteDoc, doc, fbDb, setEditingReview, setReviewForm, setStep, saveReviews }) {
  return (
            <div className="animate-in">
              {viewingCommunityTrip ? (
                <GlassCard>
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
                    <button onClick={()=>setViewingCommunityTrip(null)}
                      className="text-sm" style={{ padding:"6px 14px", borderRadius:9, border:`1px solid ${dm?"rgba(129,140,248,0.25)":"rgba(99,102,241,0.25)"}`, background:"transparent", color:"var(--text)", fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                      ← 목록으로
                    </button>
                    <div style={{ flex:1 }}>
                      <div className="text-base" style={{ fontWeight:800, color:"var(--accent)" }}>✈️ {viewingCommunityTrip.destination} 여행</div>
                      <div className="text-xs" style={{ color:dm?"rgba(226,232,240,0.70)":"rgba(51,65,85,0.65)" }}>{viewingCommunityTrip.name} · {viewingCommunityTrip.startDate}~{viewingCommunityTrip.endDate}</div>
                    </div>
                  </div>
                  <ItineraryDisplay content={viewingCommunityTrip.itinerary||""} spots={viewingCommunityTrip.spots||[]} darkMode={darkMode}/>
                </GlassCard>
              ) : (
                <>
                {/* 커뮤니티·후기 읽기는 로그인 회원만 가능하다(firestore.rules).
                    안내 없이 두면 목록이 비어 "아직 아무도 안 썼다"로 읽힌다 — 사실이 아니다. */}
                {!loggedInUser && (
                  <GlassCard className="animate-in" style={{ marginBottom:14 }}>
                    <div style={{ textAlign:"center", padding:"6px 4px" }}>
                      <div style={{ fontSize:34, marginBottom:8 }}>🔒</div>
                      <p className="text-sm" style={{ fontWeight:800, color:"var(--text)", marginBottom:5 }}>
                        로그인하면 다른 여행자들의 일정과 후기를 볼 수 있어요
                      </p>
                      <p className="text-xs" style={{ color:"var(--muted)", lineHeight:1.6, marginBottom:12 }}>
                        공유된 일정에는 작성자의 여행 정보가 담겨 있어 회원에게만 공개합니다.
                      </p>
                      <button
                        type="button"
                        onClick={() => setStep("login")}
                        className="btn3d text-sm"
                        style={{ ...btn3d("primary", dm), padding:"11px 26px", minHeight:44, borderRadius:12, fontWeight:800 }}
                      >
                        로그인하고 둘러보기
                      </button>
                    </div>
                  </GlassCard>
                )}
                <CommunityView
                  authRequired={!loggedInUser}
                  communityTrips={communityTrips}
                  reviews={reviews}
                  myName={personal.name}
                  personal={personal}
                  savedTrips={savedTrips}
                  onShareSavedTrip={loggedInUser ? shareSavedTripToCommunity : null}
                  sharedTripIds={sharedTripIds}
                  darkMode={darkMode} t={t}
                  onViewTrip={(trip) => setViewingCommunityTrip(trip)}
                  onDeleteTrip={async (tripIdOrIdx) => {
                    const tripToDelete = communityTrips.find((tr,i) => (tr.id||i.toString()) === tripIdOrIdx.toString());
                    if (tripToDelete?._docId) {
                      try { await deleteDoc(doc(fbDb, "community", tripToDelete._docId)); } catch(e) {}
                    }
                    setCommunityTrips(prev => prev.filter((tr,i) => (tr.id||i.toString()) !== tripIdOrIdx.toString()));
                  }}
                  onEditReview={(review) => {
                    setEditingReview(review.id);
                    setReviewForm({
                      rating: review.rating,
                      hoverRating: 0,
                      title: review.title,
                      content: review.content,
                      scores: review.scores || { food:0, stay:0, sight:0, move:0 },
                      photos: review.photos || [],
                    });
                    setStep("review");
                  }}
                  onDeleteReview={(id) => {
                    const updated = reviews.filter(r => r.id !== id);
                    saveReviews(updated);
                  }}
                />
                </>
              )}
            </div>
  );
}
